import 'antd/dist/antd.css';

// eslint-disable-next-line import/prefer-default-export
export const onClientEntry = () => {
  window.dataLayer = window.dataLayer || [];
};
